import { System, QueriesObject, Entity, QueryResults } from '../../../odie';
import { GameScene } from '../../GameScene';
import { BlockComponent } from '../../components/BlockComponent';
import { PhaseComponent } from '../../components/PhaseComponent';
import { MagicBunniesBlockComponent } from './MagicBunniesBlockComponent';
import { MagicBunniesBlockEntity } from './MagicBunniesBlockEntity';

export class MagicBunniesBlockSystem implements System {
  public static readonly NAME = 'blockMagicBunnies';
  public static Queries: QueriesObject = {
    block: {
      components: [BlockComponent, MagicBunniesBlockComponent],
    },
    phase: {
      components: [PhaseComponent],
      modified: true,
    },
  };

  public scene!: GameScene;
  public queries!: QueryResults;
  private lastMoveCount?: number;

  public modifiedQuery(
    entity: Entity,
    component: PhaseComponent,
    properties: { phase: string },
  ) {
    // Magic bunnies should be recovered only:
    // 1 - When the puzzle enters the input phase
    // 2 - The player has made a move (moved is true)
    // 3 - It's not the first round (round > 0)
    if (component.phase === 'input' && component.moved && component.round > 0) {
      this.recoverMagicBunnies();
    }
  }

  private recoverMagicBunnies() {
    this.queries.block.forEach((entity: MagicBunniesBlockEntity) => {
      const magicBunnies = entity.c.blockMagicBunnies;
      if (!magicBunnies.gotHit) {
        // Increase the count by 1 if the block was not hit
        magicBunnies.count += 1;
      }
      // Reset the gotHit flag for the next round
      magicBunnies.gotHit = false;
    });
  }
}
